import React, { Component } from 'react';
import Link from '@mui/material/Link';
import Title from './Title';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

function preventDefault(event) {
  event.preventDefault();
}

class TotalAlerts extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <Title>Total Alerts</Title>
        <Stack sx={{ width: '100%' }} spacing={1}>
          <Alert severity="error">Circuit Breaker due for maintenance</Alert>
          <Alert severity="warning">Check temperature on transformer</Alert>
          <Alert severity="success">Station is all clear</Alert>
        </Stack>
        <div>
          <Link color="primary" href="#" onClick={preventDefault}>
            View all
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default TotalAlerts;
